export const checkObjectBooleanValues = (object) => {
  var hasFalseKeys = Object.keys(object).some((key) => !object[key]);
  return hasFalseKeys;
};

export const checkObjectBooleanTrueValues = (object) => {
  var hasTrueKeys = Object.values(object).includes(true);
  return hasTrueKeys;
};
